import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, ChevronRight } from 'lucide-react';
import { siteConfig } from '../data/mock';

const Footer = () => {
  return (
    <footer style={{ background: 'linear-gradient(180deg, #1c2a1f 0%, #0a1f0c 100%)' }}>
      <div className="max-w-6xl mx-auto px-4 pt-14 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand */}
          <div>
            <div className="mb-4 flex items-center gap-2">
              <img 
                src="/logo.png" 
                alt="B2BTechLeads" 
                className="h-10 w-auto"
              />
              <div className="flex items-center">
                <span style={{ color: '#43a047' }} className="font-extrabold text-xl">B2B</span>
                <span className="font-extrabold text-xl text-white mx-0.5">TECH</span>
                <span style={{ color: '#43a047' }} className="font-extrabold text-xl">LEADS</span>
              </div>
            </div>
            <p className="text-sm text-white/80 leading-relaxed mb-5">
              Founded in 2008, B2BTechLeads is a global leader in marketing outsourcing and database marketing with 200+ employees.
            </p>
            <div className="flex gap-2">
              <a
                href={siteConfig.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full"
                style={{ backgroundColor: 'rgba(67,160,71,0.25)', transition: 'background 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#43a047'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(67,160,71,0.25)'}
              >
                <Linkedin size={15} className="text-white" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold mb-5 text-sm uppercase tracking-wider flex items-center gap-2">
              <span className="w-5 h-0.5 rounded" style={{ background: '#43a047' }} />
              Product & Services
            </h3>
            <ul className="space-y-2.5">
              {[
                { label: 'Marketing Leads', href: '/marketing-leads' },
                { label: 'Technology Leads', href: '/technology-leads' },
                { label: 'Nurture Marketing', href: '/nurture-marketing' },
                { label: 'Database Assessment', href: '/database-assessment' },
                { label: 'Market Survey', href: '/market-survey' },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="flex items-center gap-1.5 text-sm text-white/80 hover:text-white"
                    style={{ transition: 'color 0.2s' }}
                  >
                    <ChevronRight size={11} className="text-white/50" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Challenges */}
          <div>
            <h3 className="text-white font-bold mb-5 text-sm uppercase tracking-wider flex items-center gap-2">
              <span className="w-5 h-0.5 rounded" style={{ background: '#43a047' }} />
              Your Challenges
            </h3>
            <ul className="space-y-2.5">
              {[
                { label: 'Need More Leads', href: '/need-more-leads' },
                { label: 'Email Campaign Reports', href: '/email-campaign-reports' },
                { label: 'Brand Awareness', href: '/brand-awareness' },
                { label: 'Marketing Database', href: '/marketing-database' },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="flex items-center gap-1.5 text-sm text-white/80 hover:text-white"
                    style={{ transition: 'color 0.2s' }}
                  >
                    <ChevronRight size={11} className="text-white/50" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold mb-5 text-sm uppercase tracking-wider flex items-center gap-2">
              <span className="w-5 h-0.5 rounded" style={{ background: '#43a047' }} />
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${siteConfig.phone}`}
                  className="flex items-start gap-3 text-sm text-white/80 hover:text-white"
                  style={{ transition: 'color 0.2s' }}
                >
                  <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(67,160,71,0.25)' }}>
                    <Phone size={13} style={{ color: '#43a047' }} />
                  </div>
                  {siteConfig.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="flex items-start gap-3 text-sm text-white/80 hover:text-white"
                  style={{ transition: 'color 0.2s' }}
                >
                  <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(67,160,71,0.25)' }}>
                    <Mail size={13} style={{ color: '#43a047' }} />
                  </div>
                  {siteConfig.email}
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-sm text-white/80">
                  <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(67,160,71,0.25)' }}>
                    <MapPin size={13} style={{ color: '#43a047' }} />
                  </div>
                  {siteConfig.address}
                </div>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-xs text-white/60">
            © {new Date().getFullYear()} B2BTechLeads. All Rights Reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-5">
            <Link to="/privacy-policy" className="text-xs text-white/60 hover:text-white" style={{ transition: 'color 0.2s' }}>
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-xs text-white/60 hover:text-white" style={{ transition: 'color 0.2s' }}>
              Terms of Service
            </Link>
            <Link to="/do-not-sell" className="text-xs text-white/60 hover:text-white" style={{ transition: 'color 0.2s' }}>
              Do Not Sell My Information
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
